<div class="cluster-card">
  <div class="cluster-card__header">
    @if (cluster.name | isNotEmpty) {
      <h2>{{ cluster.name }}</h2>
    } @else {
      <h2>{{ cluster.clusterId }}</h2>
    }

    <app-options-button>
      <app-popover-item
        (click)="openEditNameDialog()"
        [label]="'cluster.editName' | translate"
        icon="edit"
      ></app-popover-item>

      <app-popover-item
        (click)="openDeleteClusterDialog()"
        [label]="'cluster.delete' | translate"
        icon="delete"
      ></app-popover-item>
    </app-options-button>
  </div>

  <div class="cluster-card__body">
    <div class="cluster-card__column">
      <div class="cluster-card__row">
        <p translate>cluster.id</p>
        <p>{{ cluster.clusterId }}</p>
      </div>

      <div class="cluster-card__row">
        <p translate>cluster.domain</p>
        <p>{{ cluster.domain }}</p>
      </div>
    </div>

    <div class="cluster-card__column">
      <div class="cluster-card__row">
        <p translate>cluster.version</p>
        <p>{{ cluster.version }}</p>
      </div>

      <div class="cluster-card__row">
        <p translate>cluster.secret</p>

        <div class="cluster-card__secret">
          <p>{{ maskedSecret }}</p>

          <app-copy-tooltip [value]="cluster.clusterSecret">
            <mat-icon fontSet="material-icons-outlined">content_copy</mat-icon>
          </app-copy-tooltip>
        </div>
      </div>
    </div>

    <div class="cluster-card__column">
      <div class="cluster-card__row">
        <p translate>cluster.created</p>
        <p>{{ cluster.createdAt | timestamp }}</p>
      </div>

      <div class="cluster-card__row">
        <p translate>cluster.updated</p>
        <p>{{ cluster.updatedAt | timestamp }}</p>
      </div>
    </div>
  </div>
  <!-- Usage statistics / limits -->

  <h2 class="subtitle">{{ "dashboard.resourceUsage" | translate }}</h2>
  <table class="usage-table">
    <thead>
      <tr>
        <th translate>dashboard.resource</th>
        <th translate>dashboard.inUseAndLimits</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td translate>dashboard.entity.users</td>
        <td>
          {{ cluster.statistics?.usersCount ?? "-" }} /
          {{ cluster.limits?.users ?? "-" }}
        </td>
      </tr>

      <tr>
        <td>
          <app-tooltip [label]="'dashboard.tooltip.includeArchived' | translate">
            <span translate>dashboard.entity.deployments</span>
          </app-tooltip>
        </td>
        <td>
          {{ cluster.statistics?.totalDeploymentsCount ?? "-" }} /
          {{ cluster.limits?.deployments ?? "-" }}
        </td>
      </tr>
      <tr class="deployment-type">
        <td>
          <app-tooltip [label]="'dashboard.tooltip.excludeArchived' | translate">
            <small translate>dashboard.entity.managedDeployments</small>
          </app-tooltip>
        </td>
        <td>
          {{ cluster.statistics?.kserveDeploymentsCount ?? "-" }} /
          {{ cluster.limits?.kserveDeployments ?? "-" }}
        </td>
      </tr>
      <tr class="deployment-type">
        <td>
          <app-tooltip [label]="'dashboard.tooltip.excludeArchived' | translate">
            <small translate>dashboard.entity.externalDeployments</small>
          </app-tooltip>
        </td>
        <td>
          {{ cluster.statistics?.externalDeploymentsCount ?? "-" }} /
          {{ cluster.limits?.externalDeployments ?? "-" }}
        </td>
      </tr>
      <tr class="deployment-type">
        <td>
          <app-tooltip [label]="'dashboard.tooltip.excludeArchived' | translate">
            <small translate>dashboard.entity.registrationDeployments</small>
          </app-tooltip>
        </td>
        <td>
          {{ cluster.statistics?.registrationDeploymentsCount ?? "-" }} /
          {{ cluster.limits?.registrationDeployments ?? "-" }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
